module.exports = __webpack_public_path__ + "img/product2.873dfb25.png";